import { Actions } from 'vuex-smart-module';
import { Filters } from '@/types';
import { AnalyticsSections } from '@/enums';
import { AnalyticsService } from '../services';
import AnalyticsState from './state';
import AnalyticsMutations from './mutations';
import AnalyticsGetters from './getters';
import { Analytics } from '../types';

const analyticsService = new AnalyticsService();

export default class AnalyticsActions extends Actions<
  AnalyticsState,
  AnalyticsGetters,
  AnalyticsMutations,
  // eslint-disable-next-line no-use-before-define
  AnalyticsActions
> {
  async get_analytics() {
    try {
      this.mutations.TOGGLE_SECTION_LOADING(true);

      const { data } = await analyticsService.get_analytics();

      this.mutations.SET_ANALYTICS(data.items);
      this.mutations.SET_USERS(data.users);
      this.mutations.SET_ORGANIZATIONS(data.organizations);
      this.mutations.SET_EXTERNAL_ORG(data.external_organization);
      this.mutations.SET_CATEGORIES(data.course_categories);
      this.mutations.SET_OPERATION_TYPES(data.order_side_operation_types);
      this.mutations.SET_REPAIRS_TYPES(data.order_side_repair_types);
      this.mutations.SET_REGIONS(data.lead_regions);
      this.mutations.SET_CLIENTS(data.clients);
      this.mutations.SET_ORDER_SIDE_NUMBERS(data.order_side_numbers);
      this.mutations.SET_YEARS(data.years);
      this.mutations.SET_CREDIT_LINE_CONTRACTS(data.credit_line_contracts);
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_SECTION_LOADING(false);
    }
  }

  async get_analytics_filters(section: string) {
    try {
      const payload: Filters = {
        filters: this.state.filters,
      };

      this.dispatch('get_toggle_section');

      const { data } = await analyticsService.get_analytics_filters(payload, section);

      const { items, credit_line_contracts } = data;

      const sections: (keyof typeof items)[] = [
        'orders', 'certs', 'returns_zip', 'order_sides', 'repair_models', 'leads', 'repair_types', 'result_service_activity', 'credit_line',
      ];

      sections.forEach((key) => {
        if (items[key] !== undefined && items[key] !== null) {
          this.mutations.SET_RESPONSE_FILTERS(items[key] as Analytics.Section);
        }
      });

      if (credit_line_contracts !== undefined && credit_line_contracts !== null) {
        this.mutations.SET_CREDIT_LINE_CONTRACTS(credit_line_contracts);
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_SECTION_LOADING(false);
    }
  }

  get_toggle_section() {
    const { section } = this.state;

    switch (section) {
      case AnalyticsSections.ORDERS:
      case AnalyticsSections.CERTS:
      case AnalyticsSections.RETURNS_ZIP:
      case AnalyticsSections.ORDER_SIDES:
      case AnalyticsSections.REPAIR_MODELS:
      case AnalyticsSections.LEADS:
      case AnalyticsSections.REPAIR_TYPES:
      case AnalyticsSections.RESULT_SERVICE_ACTIVITY:
      case AnalyticsSections.CREDIT_LINE:
        return this.mutations.TOGGLE_SECTION_LOADING(true);

      default:
        return this.mutations.TOGGLE_SECTION_LOADING(false);
    }
  }
}
